import { getPlanVente } from '../../../api/planVente'
import * as types from './mutation-types'
import * as constants from '../modal/modal-constants'

const initialState = {
    selected: null,
    index: {},
    searchArticle: ''
}

const state = { ...initialState }
const mutations = {
    [types.SET_PLAN_VENTE](state, planVente) {
        state.index = planVente
    },
    [types.SELECT_PLAN_VENTE](state, codeFamille) {
        state.selected = codeFamille
    },
    [types.RESET_PLAN_VENTE](state) {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key] = value
        })
    },
    [types.SET_SEARCH_STRING](state, value) {
      state.searchArticle = value
    }
}
const actions = {
    async getPlanVente({ commit }, famille = null) {
        const planVente = await getPlanVente(famille)
        commit(types.SET_PLAN_VENTE, planVente)
    },
    async openPlanVenteBrowser({ dispatch }) {
        await dispatch('getPlanVente')
        dispatch('openModal', { type: constants.PLAN_VENTE_BROWSER_MODAL })
    },
    clickPlanVente({ state, commit }, code) {
        if (state.selected === code) code = null
        commit(types.SELECT_PLAN_VENTE, code)
    },
    resetPlanVente({ commit }) {
        commit(types.RESET_PLAN_VENTE)
    },
    setSearchString({ commit }, event) {
      commit(types.SET_SEARCH_STRING, event.target.value)
  }
}
const getters = {
    planVente: state => state.index,
    selectedPlanVente: state => state.selected,
    searchArticle: state => state.searchArticle
}
export default { state, mutations, actions, getters }
